import React, { useState, useEffect } from "react";
import "./index.css";
import news from "../../assets/new1.png";
import news1 from "../../assets/new.png";
import news2 from "../../assets/new2.png";
import news3 from "../../assets/new3.png";
import news4 from "../../assets/news5.png";
import news5 from "../../assets/new5.png";
import news6 from "../../assets/new6.png";

import news7 from "../../assets/news8.png";

import { useLocation } from "react-router-dom";
import { Pagination } from "antd";
import axios from 'axios';
export default function News(props) {
  const [isSho, setIsSho] = useState(true);

  const location = useLocation();
  const [shuju, setData] = useState(null);
  useEffect(() => {
    console.log(location);
    if (location.pathname === "/news") {
      setIsSho(true);
    }
    if (location.pathname !== "/news") {
      setIsSho(false);
    }
  }, [location]);
  useEffect(() => {
    const fetchData = async () => {

      // try {
      //   const response = await axios.post('https://gateway-cloud.supos.com/owe-core/devc/information/list', {
      //     current: 1,
      //     isTop: 1,
      //     pageSize: 9,
      //     type: "information_type_001",
      //   });
      //   console.log(response.data, '接口获取数据')
      //   setData(response.data)

      // } catch (error) {
      //   console.log(error, 'error');
      // }
      // 修改后

      try {
        const response = await axios.post('https://gateway-cloud.supos.com/basic-common/information/list', {
          current: 1,
          isTop: 1,
          pageSize: 9,
          type: "information_type_001",
        });
        console.log(response.data, '接口获取数据')
        setData(response.data)

      } catch (error) {
        console.log(error, 'error');
      }

    };

    fetchData();
    // 测试

    const test = async () => {
      const clientIP = '192.168.1.11'
      // 

      try {
        // 请求
        const response = await axios.post('api/tums/account/v1/login', {
          body: JSON.stringify(
            {
              username: 'admin',
              password: 'Supcon124'
            }
          )

        }, {
          headers: {
            'Content-Type': 'application/json',
            // 'Referer': `https://${clientIP}:8888/` 
          }
        });
        console.log(response.data, '测试通过post请求接口获取数据')

      } catch (error) {
        console.log(error, 'error');
      }
    };

    test();



  }, []); // 空数组表示这个effect只会在组件挂载和卸载时运行一次  

  const [number, setNumber] = useState({
    minValue: 0,
    maxValue: 8,
  });
  function handleChange(value) {
    if (value <= 1) {
      setNumber({
        minValue: 0,
        maxValue: 3,
      });
    } else {
      setNumber({
        minValue: (value - 1) * 3,
        maxValue: (value - 1) * 3 + 3,
      });
    }
  }
  const [mess] = useState([
    {
      id: 1,
      patent: "https://bluetron-eco.oss-cn-hangzhou.aliyuncs.com/owe/images/information/9b819149b80145f1815014a98eba7258.png",
      href: "https://mp.weixin.qq.com/s/zUStYCxUpis3ZeOC-KXC7g",
      title: "开工双喜！蓝卓两大项目入选工信部2023工业互联网试点示范",
      time: "发布时间:2023-04-30 10:38:04",
    },
    {
      id: 2,
      patent: news,
      href: "https://www.supos.com/aboutNewsdetail?id=1646543773946294272",
      title: "能耗“双控”下的危与机，氯碱行业如何在产业大变革中再起锚？",
      time: "发布时间:2023-04-13 17:39:06",
    },
    {
      id: 3,
      patent: news2,
      href: "https://www.supos.com/aboutNewsdetail?id=1641107956040290304",
      title: "蓝卓出席中国数字经济产业发展大会，为数字经济发展建言献策",
      time: "发布时间:2023-03-29 08:42:09",
    },
    {
      id: 4,
      patent: news3,
      href: "https://www.supos.com/aboutNewsdetail?id=1637846463947837440",
      title: "蓝卓亮相云桥大会,与2000+企业共论数据驱动力",
      time: "发布时间:2023-03-20 10:50:39",
    },
    {
      id: 5,
      patent: news4,
      href: "https://www.supos.com/aboutNewsdetail?id=1637846463905894400",
      title: "蓝卓成功入选2022年成渝地区工业互联网及智能制造服务商资源池",
      time: "发布时间:2023-03-20 11:13:28",
    },
    {
      id: 6,
      patent: news5,
      href: "https://www.supos.com/aboutNewsdetail?id=1633860198094950400",
      title: "“取经”数字化转型！大连市数字化转型专班办公室莅临蓝卓参观调研",
      time: "发布时间:2023-03-09 17:45:33",
    },

    {
      id: 7,
      patent: news6,
      href: "https://www.supos.com/aboutNewsdetail?id=1639296016601419776",
      title: "2022世界互联网大会乌镇峰会,蓝卓共建工业数字化新生态",
      time: "发布时间:2023-02-16 17:45:26",
    },
    {
      id: 8,
      patent: news7,
      href: "https://www.supos.com/aboutNewsdetail?id=169",
      title: "蓝卓创始人褚健：工厂操作系统+APP,加速工业数字化转型",
      time: "发布时间:2022-11-09 08:05:00",
    },
  ]);


  return (
    <div>
      <div className="third news_list">
        <h2>新闻动态</h2>
        <div className="xian"></div>
        <div className="en">News List</div>
        {
          shuju ? shuju.data.list.map((item) => {
            console.log(item, 'item')
            return (
              <div className="news">
                <div className="thumb">
                  <img
                    src={item.coverUrl}
                    alt=""
                    style={{ height: "240px", width: "400.1px" }}
                  />
                </div>
                <div className="news_content">
                  <a href={"https://www.supos.com/aboutNewsdetail?id=" + item.id} target="_blank" rel="noopener noreferrer">
                    <div className="Newtit">{item.title}</div>
                    <div className="time">发布时间：{item.issueTime}</div>
                    <div className="Xcontent">{item.introduction}</div>
                  </a>
                </div>
              </div>
            );

          }) : null
        }
      </div>
    </div>
  );
}
